export enum LocalProgramSubmitTypes {
  xboxGamePass = "xboxGamePassForProspectivePrograms",
  developerAccelerationProgramPorting = "developerAcceletarionProgramPorting",
  developerAccelerationProgramPrototype = "developerAcceletarionProgramPrototype",
  other = "Other",
}
